import api from 'Application/api/api';

const uploadPostCompletionDocuments = async (signal, files, postCompletionId, type) => {
	const response = await api.post(`/post-completions/${postCompletionId}/upload-document`, files, {
		signal,
		timeout: 100000,
		headers: {
			'Content-Type': 'multipart/form-data',
			Accept: '*/*',
		},
		params: {
			type: type,
		},
	});

	if (!response || !response.data) {
		return response;
	}

	return {
		...response,
	};
};

export default uploadPostCompletionDocuments;
